import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Martín', 'Sofía', 'Diego', 'Camila', 'Alejandro', 'Florencia', 'Nicolás', 'Valentina', 'Matías', 'Julieta', 'Federico', 'Carolina', 'Sebastián', 'Paula', 'Gonzalo'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Auto-dismiss after 4 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 5000);
    // Subsequent popups every 8-12 seconds
    const intervalTimer = setInterval(() => {
      if (!isVisible) {
        setTimeout(showPopup, Math.random() * 4000 + 8000);
      }
    }, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-157">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-[#0B0B1A] border border-[#00D4FF]/30 rounded-lg shadow-2xl p-4 flex items-center gap-4" data-id="element-158">
          <div className="flex-shrink-0" data-id="element-159">
            <img src="https://cdn.magicpatterns.com/uploads/ibm6jBTNSEkwpcfh2tSvYZ/MOCKUP_(2).png" alt="Product thumbnail" className="w-12 h-12 object-cover rounded shadow-sm" data-id="element-160" />
          </div>
          <div data-id="element-161">
            <div className="flex items-center gap-1 text-xs text-[#00FF66] font-semibold mb-1" data-id="element-162">
              <CheckCircle2 className="w-3 h-3" data-id="element-163" />
              <span data-id="element-164">Compra verificada</span>
            </div>
            <p className="text-sm text-white leading-tight" data-id="element-165">
              <span className="font-bold text-[#00D4FF]" data-id="element-166">
                {currentData.name}
              </span>{' '}
              de {currentData.city} acaba de comprar este libro digital
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-167">Hace unos segundos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}